module.exports = __webpack_public_path__ + "img/4edb0f9.jpg";